module.exports = __webpack_public_path__ + "media/images/fallback/figures/article_box_default-28f78253afa1adefe3e2bcdb029e78fa.gif";